<link href="
https://cdn.jsdelivr.net/npm/@chgibb/css-spinners@2.2.1/css/spinners.min.css
" rel="stylesheet">

<!-- <div class="topnav">
  <img height=50px src="../assets/angular-logo.png" />
  <mat-icon class="logout" (click)="signOut()" title="Logout">logout</mat-icon>
</div> -->

<!-- <div class="auth-wrapper" style="background-color: aquamarine;" *ngIf="load_face_live"> -->
  <amplify-authenticator *ngIf="!isAutoLoginInProgress">
    <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
      <app-face-liveness *ngIf="load_face_live"></app-face-liveness>
    </ng-template>
  </amplify-authenticator>
  <div class="spinner-loader" *ngIf="isAutoLoginInProgress">
    <h1>Loading...</h1>
  </div>
<!-- </div> -->
